var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98596 8.8352C10.8044 8.8352 12.2786 7.36105 12.2786 5.5426C12.2786 3.72415 10.8044 2.25 8.98596 2.25C7.16751 2.25 5.69336 3.72415 5.69336 5.5426C5.69336 7.36105 7.16751 8.8352 8.98596 8.8352Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98597 10.4818C5.68676 10.4818 3 12.6944 3 15.4207C3 15.6051 3.14487 15.75 3.32926 15.75H14.6427C14.827 15.75 14.9719 15.6051 14.9719 15.4207C14.9719 12.6944 12.2852 10.4818 8.98597 10.4818Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.a6686e583da512e0d82bfeb742397a2d.svg";
export { ForwardRef as ReactComponent };